import { render } from "./AlertsAssignee.vue?vue&type=template&id=7aaf0e62"
import script from "./AlertsAssignee.vue?vue&type=script&lang=js"
export * from "./AlertsAssignee.vue?vue&type=script&lang=js"

import "./AlertsAssignee.vue?vue&type=style&index=0&id=7aaf0e62&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__